import module from './change-password.module';
import _ from 'lodash';

module.controller('ChangePasswordController', [
  'UserAccountService',
  function (UserAccountService) {
    var ctrl = this;

    ctrl.getResetToken = function () {
      var url = new URL(window.location.href);
      var token = url.searchParams.get('token');
      return token;
    };

    ctrl.init = function () {
      ctrl.changingPassword = false;
      ctrl.changeSuccess = false;
      ctrl.resetToken = ctrl.getResetToken();
      ctrl.hasResetToken = !!ctrl.resetToken;
    };

    ctrl.checkNewPasswords = function (form) {
      form.password.$setValidity('newPasswordMismatch', true);
      form.newPasswordVerify.$setValidity('newPasswordMismatch', true);

      if (ctrl.newPassword !== ctrl.newPasswordVerify) {
        form.password.$setValidity('newPasswordMismatch', false);
        form.newPasswordVerify.$setValidity('newPasswordMismatch', false);
      }
    };

    ctrl.changePassword = function (form) {
      ctrl.checkNewPasswords(form);

      if (form.$valid) {
        ctrl.changingPassword = true;
        ctrl.errorMessage = '';

        UserAccountService.changePassword(ctrl.resetToken, ctrl.username, ctrl.oldPassword, ctrl.newPassword)
          .then(function (result) {
            if (result.success) {
              ctrl.changeSuccess = true;
            } else {
              ctrl.errorMessage = result.msg;
            }
          })
          .finally(function () {
            ctrl.changingPassword = false;
          });
      }
    };

    ctrl.init();
  },
]);
